import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryDeductionRule  {
    _originalTypeClassName = "zERP.BO.SalaryDeductionRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryDeductionRule.translate = translateService;
}
this.AvailableSalaryPeriods = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.DateFrom = null;
this.ExpirationDate = null;
this.Priority = null;
this.IsActive = false;
this.Notes = null;
this.IsPercentage = false;
this.IsCalculatedBeforeTax = false;
this.OpenPeriodHandling = null;
this.ApplyRuleFor = null;
this.KaeCode = null;
this.EapCode = null;
this.EapCodeEmployer = null;
this.isLoan = false;
this.LoanNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
DateFrom:any;
ExpirationDate:any;
Priority:any;
IsActive:any;
Notes:any;
IsPercentage:any;
IsCalculatedBeforeTax:any;
OpenPeriodHandling:any;
ApplyRuleFor:any;
KaeCode:any;
EapCode:any;
EapCodeEmployer:any;
isLoan:any;
LoanNumber:any;
AvailableSalaryPeriods:any;
EmployeeData:any;
EmployerData:any;
AccountingConfig:any;
static setAvailableSalaryPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.AvailableSalaryPeriods == null) $this.AvailableSalaryPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AvailableSalaryPeriods.length > 0) {
                    Domain.SalaryDeductionRule.removeAvailableSalaryPeriods($this, $this.AvailableSalaryPeriods[0]);
                }

                Domain.SalaryDeductionRule.addManyAvailableSalaryPeriods($this, copyItems);
            }
static addManyAvailableSalaryPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SalaryDeductionRule.addAvailableSalaryPeriods($this, items[i]);
                }
            }
static addAvailableSalaryPeriods = ($this, item) => {
                if ($this.AvailableSalaryPeriods == null) $this.AvailableSalaryPeriods = [];
                if (item == null || $this.AvailableSalaryPeriods.indexOf(item) > -1) return;
                $this.AvailableSalaryPeriods.push(item);
}
static addRangeAvailableSalaryPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SalaryDeductionRule.addAvailableSalaryPeriods($this, item));
            }
static removeAvailableSalaryPeriods = ($this, item) => {
                if ($this == null || $this.AvailableSalaryPeriods == null || $this.AvailableSalaryPeriods.indexOf(item) === -1) return;
                var _index = $this.AvailableSalaryPeriods.indexOf(item);
                $this.AvailableSalaryPeriods.splice(_index, 1);
}
static clearAvailableSalaryPeriods = ($this) => { $this.AvailableSalaryPeriods = null; }
static setEmployeeData = ($this, value) => {
var oldValue = $this.EmployeeData;
$this.EmployeeData = value;
if (value != null) {
}
}
static setEmployerData = ($this, value) => {
var oldValue = $this.EmployerData;
$this.EmployerData = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static IsAvailable($this: any, calculation: any,availabeFrom: any,availableTo: any): any{if ($this?.IsActive != true) {return false;}
if ((new Date($this?.DateFrom).getTime()) > (new Date(calculation?.Period?.From).getTime())) {return false;}
if ($this?.ExpirationDate != null && CLMS.Framework.Number.GreaterThan(() => moment($this.ExpirationDate).year(), () => 1900) && (new Date($this?.ExpirationDate).getTime()) < (new Date(calculation?.Period?.From).getTime())) {return false;}
if (($this?.AvailableSalaryPeriods?.linq?.any() && !($this?.AvailableSalaryPeriods?.linq?.any((s) => s?.SystemType == calculation?.Type?.SystemType)))) {return false;}
if (!(Domain.DateHelper.IsDateNull(availabeFrom)) && (new Date(new Date(new Date(availabeFrom)?.setHours(0, 0, 0, 0))).getTime()) > (new Date(calculation?.Period?.From).getTime())) {return false;}
if (!(Domain.DateHelper.IsDateNull(availableTo)) && (new Date(new Date(new Date(availableTo)?.setHours(0, 0, 0, 0))).getTime()) < (new Date(calculation?.Period?.From).getTime())) {return false;}
return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}